export default {
  heading: "Forgot Password",
  typeHint: "Reset your password using either your login email <font color='#FF0000'>or</font> login ID:  ",
  emailRadioLabel: "Login email <font color='#FF0000'>or</font> contact email",
  cityIdRadioLabel: "Login ID",
  emailLabel: "Login email or contact email",
  cityIdLabel: "Login ID",
  submitBtn: "Submit",
  resetBtn: "Clear",
  closeBtn: "Close",
  emailIsEmpty: "Please enter your email address.",
  cityIdIsEmpty: "Please enter your login ID.",
  emailFormatWrong: "Invalid email address format. Please try again.",
  recaptcha_lang: "en",
  emailNotFound: "The email address you entered did not match our records. Please double check and try again.",
  cityIdNotFound: "The login ID you entered does not exist. Please double check and try again.",
  accountNoEmail: "We couldn't find a record of your login email or contact email in our system. Please reach out to your School Administrator to reset password.",
  completed:
    "We just sent you an email to the following email address(es). Click the link in the email to create a new password. ",
};
